import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

export default class ModalTrigger extends Component {
  static propTypes = {
    triggerId: PropTypes.string,
    triggerLabel: PropTypes.string,
    triggerIcon: PropTypes.string,
    triggerIconClassName: PropTypes.string,
    triggerClassName: PropTypes.string,
    onClick: PropTypes.func,
    listenTo: PropTypes.string,
    listenAt: PropTypes.string,
  };

  static defaultProps = {
    triggerId: null,
    triggerLabel: '',
    triggerClassName: 'u-text-old-primary-color-blue',
    triggerIcon: null,
    triggerIconClassName: '',
    listenTo: null,
    listenAt: null,
  }

  constructor(props) {
    super(props)

    this.triggerRef = React.createRef();
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    if (this.props.listenTo) {
      $(document).on(...([this.props.listenTo, this.props.listenAt, this.open].filter(x => !!x)));
    }
  }

  componentWillUnmount() {
    if (this.props.listenTo) {
      $(document).off(...([this.props.listenTo, this.props.listenAt, this.open].filter(x => !!x)));
    }
  }

  open = () => {
    this.setState({ open: true });
  }

  handleClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    if (this.triggerRef.current.contains(e.target)) {
      this.open();
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  render() {
    const { listenTo, listenAt, triggerLabel, triggerClassName, triggerIcon, triggerIconClassName, triggerId, 'data-action': dataAction, ...otherProps } = this.props;
    return (
      <a ref={this.triggerRef} onClick={this.handleClick} className={`${triggerClassName}`} id={triggerId} data-action={dataAction}>
        {this.props.children}
        {triggerIcon && !this.props.children && (<i className={`${triggerIcon} ${triggerIconClassName}`} />)}
        {!this.props.children && triggerLabel}
        <Modal key={otherProps.asyncUrl} onClose={this.handleClose.bind(this)} {...otherProps} visible={this.state.open} />
      </a>
    );
  }
}
